export const zdbAuthRouteNames = {
  selectRole: 'select-role',
  onboarding: 'onboarding',
  selfOnboarding: 'self',
  healthcareProviderOnboarding: 'healthcare-provider',
};
